<template>
    <div class="">
        <el-popover
            ref="popover"
            placement="bottom"
            width="148"
            trigger="click"
            popper-class="dark-popper"
            @hide="hideSubscribePopover"
        >
            <div v-if="!profilePopOverOpenned">
                <div class="popover-title">
                    <template v-if="broadcastRight">
                        CONFIRM REMOVE RIGHT (WARNING, THIS WILL STOP THE CHANNEL FOR THIS TAKER)
                    </template>
                    <template v-else>
                        CONFIRM ADD RIGHT
                    </template>
                ?</div>
                <div class="actions">
                    <el-button type="text" class="decline" @click="hideSubscribePopover()">No</el-button>
                    <el-button type="text" class="accept" @click="changeRight()">Yes</el-button>
                </div>
            </div>
            <div v-else-if="isBlankable">
                <div class="popover-title">
                    <template>
                        DO YOU WANT TO ADD THIS TAKER TO A PROFILE
                    </template>
                ?</div>
                <div class="actions">
                    <el-button type="text" class="decline" @click="hideSubscribeProfilePopover()">No</el-button>
                    <el-button type="text" class="accept" @click="addProfileRights()">Yes</el-button>
                </div>
            </div>
            <el-button
                slot="reference"
                :disabled="channelFinished || isConfigured"
                :loading="loading"
                type="primary"
                class="gcmcn-primary-btn small manage-right-btn"
                :class="{'has-right': broadcastRight, 'expanded' : popOverOpenned}"
                :icon="iconToDisplay"
                @click="popOverOpenned = true"
            >
            {{ textToDisplay }}</el-button>
        </el-popover>

    </div>
</template>

<script>

export default {

    components: {

    },

    props: {
        channel: {
            type: Object,
            required: true,
        },
        broadcastRight: {
            required: true,
            validator: prop => typeof prop === 'object' || prop === null,
        },
        channelFinished: {
            type: Boolean,
            required: false,
            default: false
        },
        isConfigured:{
            type: Boolean,
            required: false,
        }
    },

    data (){
        return {
            loading: false,
            popOverOpenned: false,
            profilePopOverOpenned: false,
        };
    },

    computed: {
        iconToDisplay (){
            return this.broadcastRight === null ? 'ti-control-stop' : 'ti-check-box';
        },
        textToDisplay (){
            return this.broadcastRight === null ? 'Add right' : 'Remove right';
        },
        isBlankable(){
            if(this.profilePopOverOpenned && !this.broadcastRight && this.channel.is_blankable){
                return true;
            }
            return false;
        }
    },

    mounted (){
        this.$eventBus.$on('broadcast-right-save-ended', () => {
            this.loading = false;
        });
    },

    beforeDestroy (){
        this.$eventBus.$off('broadcast-right-save-ended');
    },

    methods: {
        addProfileRights(){
            this.$emit('add-profile-broadcast-right');
            this.hideSubscribePopover();
        },
        changeRight (){
            if(this.broadcastRight){
                this.hideSubscribePopover();
                this.loading = true;
                this.$emit('delete-broadcast-right');
            } else if(!this.channel.is_blankable) {
                this.hideSubscribePopover();
                this.loading = true;
                this.$emit(this.broadcastRight ? 'delete-broadcast-right' : 'create-broadcast-right');
            } else {
                this.profilePopOverOpenned = true;
            }
        },
        hideSubscribePopover() {
            this.popOverOpenned = false;
            this.profilePopOverOpenned = false;
            if (this.$refs['popover']) {
                this.$refs['popover'].showPopper = false;
            }
        },
        hideSubscribeProfilePopover() {
            this.hideSubscribePopover();
            this.$emit('create-broadcast-right');
        },
    },
};
</script>

<style lang="scss">
.manage-right-btn{
    width: 24px;
    i + span{
        display: none;
    }
    &:hover, &.expanded{
        width: 100px;
        &.has-right{
            width: 120px;
        }

        i + span{
            display: initial;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/partials/manage-broadcast-right-channels.vue